import { useMemo } from 'react';
import { BootResponse, ResolvedStoreSettings } from '../constants/apiResponses.types';
import { getStoreSettings } from '../utils/storeSettings';
import useApi from './useApi';

export const useStoreSettings = (): ResolvedStoreSettings => {
  const API = useApi({});
  const publisherMetaData = API.getPublisherMeta.data as BootResponse;

  return useMemo(
    () => getStoreSettings(publisherMetaData.storeTheme),
    [publisherMetaData.storeTheme]
  );
};
